import { render } from "./InternetToolBar.vue?vue&type=template&id=5e4bfd5a&scoped=true"
import script from "./InternetToolBar.vue?vue&type=script&lang=js"
export * from "./InternetToolBar.vue?vue&type=script&lang=js"

import "./InternetToolBar.vue?vue&type=style&index=0&id=5e4bfd5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4bfd5a"]])

export default __exports__